import { defineStore } from 'pinia';
import { ref } from 'vue';

// Live OpenCCMS has no dark mode. Force light theme always and clear any
// stale stored values from earlier iterations where the site defaulted dark.
type Theme = 'light';

export const useThemeStore = defineStore('theme', () => {
  const theme = ref<Theme>('light');

  if (typeof window !== 'undefined') {
    document.documentElement.setAttribute('data-theme', 'light');
    try {
      localStorage.removeItem('ccms-theme');
      localStorage.removeItem('ccms-theme-v2');
    } catch {}
  }

  function setTheme(_: Theme) { /* no-op — light only */ }
  function toggle() { /* no-op — light only */ }

  return { theme, setTheme, toggle };
});
